import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import { ButtonTitleWithLoading } from '@vyce/core/src/components/ButtonTitleWithLoading';

import { MAIN_CONTAINER_ID } from '../../../constants';

interface Props {
  open: boolean;
  setOpen: Function;
  sendEmail: Function;
  sendSMS: Function;
}

export const SendPayStatementsDialog: React.FC<Props> = ({ open, setOpen, sendEmail, sendSMS }) => {
  const [loading, setLoading] = useState<'sms' | 'email' | null>(null);

  const handleSendSMS = async () => {
    try {
      setLoading('sms');
      await sendSMS();
    } finally {
      setLoading(null);
    }
  };

  const handleSendEmail = async () => {
    try {
      setLoading('email');
      await sendEmail();
    } finally {
      setLoading(null);
    }
  };

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      onClose={() => setOpen(false)}
      open={open}
    >
      <DialogTitle>Send Bulk Pay Statements</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Pay statements will be sent by email. Net payments will be sent by SMS. Everyone in this payrun
          will receive an SMS or email unless they have already received one.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button size="large" disabled={!!loading} onClick={() => setOpen(false)} variant="outlined">
          Cancel
        </Button>
        <Button
          style={{ width: 130 }}
          size="large"
          disabled={!!loading}
          onClick={handleSendSMS}
          color="secondary"
          variant="contained"
        >
          <ButtonTitleWithLoading title="Send SMS" loaderVariant="paper" loading={loading === 'sms'} />
        </Button>
        <Button
          style={{ width: 130 }}
          size="large"
          disabled={!!loading}
          onClick={handleSendEmail}
          color="primary"
          variant="contained"
        >
          <ButtonTitleWithLoading title="Send Email" loaderVariant="paper" loading={loading === 'email'} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
